import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { CherryDevWordmark, MEDIA_LAB_TAGLINES } from 'components/TnoMediaLabLogo';
import { FARMA, HERO_IMAGE, hero } from '../farmaferContent';

const Hero = () => (
  <Box
    component="section"
    position="relative"
    overflow="hidden"
    minHeight={{ xs: '92vh', md: '100vh' }}
    display="flex"
    alignItems="flex-end"
    sx={{
      backgroundColor: FARMA.greenDeep,
      backgroundImage: `
        linear-gradient(105deg, rgba(6,74,52,0.92) 0%, rgba(10,107,74,0.78) 42%, rgba(16,36,28,0.55) 100%),
        url(${HERO_IMAGE})
      `,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: FARMA.white,
    }}
  >
    <Box
      position="absolute"
      inset={0}
      sx={{
        background:
          'radial-gradient(ellipse 70% 50% at 80% 20%, rgba(26,143,100,0.35) 0%, transparent 55%)',
        pointerEvents: 'none',
        animation: 'farmaPulse 8s ease-in-out infinite',
        '@keyframes farmaPulse': {
          '0%, 100%': { opacity: 0.7 },
          '50%': { opacity: 1 },
        },
      }}
    />

    <Box
      position="relative"
      zIndex={1}
      width="100%"
      px={{ xs: 2.5, sm: 4, md: 7 }}
      pt={{ xs: 5, md: 7 }}
      pb={{ xs: 6, md: 9 }}
      maxWidth={920}
    >
      <Box
        sx={{
          animation: 'farmaFadeUp 0.9s ease both',
          '@keyframes farmaFadeUp': {
            from: { opacity: 0, transform: 'translateY(18px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        <Box mb={{ xs: 3, md: 4 }}>
          <Typography
            component="div"
            sx={{
              fontFamily: '"Outfit", "Syne", sans-serif',
              fontSize: { xs: '1.65rem', md: '2rem' },
              lineHeight: 1,
              color: FARMA.white,
            }}
          >
            <CherryDevWordmark color="inherit" fontSize="inherit" />
          </Typography>
          <Typography
            sx={{
              mt: 0.75,
              fontFamily: '"Outfit", sans-serif',
              fontWeight: 700,
              fontSize: '0.7rem',
              letterSpacing: '0.14em',
              color: 'rgba(255,255,255,0.72)',
            }}
          >
            {MEDIA_LAB_TAGLINES.web}
          </Typography>
        </Box>

        <Typography
          component="p"
          sx={{
            fontFamily: '"Syne", "Outfit", sans-serif',
            fontWeight: 700,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            fontSize: { xs: '0.7rem', md: '0.78rem' },
            color: 'rgba(255,255,255,0.78)',
            mb: 1.5,
          }}
        >
          {hero.overline}
        </Typography>

        <Typography
          component="h1"
          sx={{
            fontFamily: '"Syne", "Outfit", sans-serif',
            fontWeight: 800,
            letterSpacing: { xs: '-0.03em', md: '-0.04em' },
            lineHeight: 0.95,
            // Escala con el viewport para que "Farmafer" no se salga en móviles angostos
            fontSize: 'clamp(2.35rem, 11.5vw, 6.5rem)',
            maxWidth: '100%',
            mb: 1,
            textShadow: '0 12px 40px rgba(0,0,0,0.25)',
          }}
        >
          {hero.clientName}
        </Typography>

        <Typography
          component="p"
          sx={{
            fontFamily: '"Syne", "Outfit", sans-serif',
            fontWeight: 700,
            fontSize: { xs: '1.25rem', md: '1.55rem' },
            letterSpacing: '-0.02em',
            lineHeight: 1.25,
            maxWidth: 560,
            mb: 2,
          }}
        >
          {hero.title}
        </Typography>

        <Typography
          component="p"
          sx={{
            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
            fontWeight: 400,
            fontSize: { xs: '1.02rem', md: '1.12rem' },
            lineHeight: 1.65,
            color: 'rgba(255,255,255,0.88)',
            maxWidth: 540,
            mb: 3.5,
          }}
        >
          <Box component="span" sx={{ fontWeight: 700, color: FARMA.white }}>
            {hero.congrats}{' '}
          </Box>
          {hero.subtitle}
        </Typography>

        <Button
          href="#inversion"
          variant="contained"
          endIcon={<ArrowDownwardIcon />}
          sx={{
            px: 3.25,
            py: 1.4,
            borderRadius: 1.5,
            fontWeight: 800,
            fontFamily: '"Syne", "Outfit", sans-serif',
            bgcolor: FARMA.white,
            color: FARMA.greenDeep,
            boxShadow: '0 16px 36px rgba(0,0,0,0.22)',
            '&:hover': {
              bgcolor: FARMA.mint,
              color: FARMA.greenDeep,
            },
          }}
        >
          {hero.cta}
        </Button>
      </Box>
    </Box>
  </Box>
);

export default Hero;
